import React, { useContext } from 'react'
import ReactDOM from 'react-dom'
import classNames from 'classnames'
import Modal from '../../assets/modalBG.svg'
import { useNavigate } from 'react-router-dom'
import UserContext from 'contexts/UserContext'
import localforage from 'localforage'
import LogOutImage from '../../assets/logOutImage.svg'
import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'
import RechargeContext from 'contexts/rechargeContext'
import paimentFactureContext from 'contexts/paimentFactureContext'

interface Props {
  isOpen: boolean
  closeModal: () => void
  handleConfirmUpdate?: () => void
  openModalLogOut: boolean
  nomModal?: string
  confirmationText?: string
  description?: string
  UpdateKYC?: (val: boolean) => void | undefined
  logOutImage?: string
}

const ModalLogOutContainer: React.FC<Props> = ({
  isOpen,
  closeModal,
  openModalLogOut,
  nomModal,
  confirmationText,
  description = '',
  handleConfirmUpdate,
  UpdateKYC,
  logOutImage,
}) => {
  const navigate = useNavigate()

  const { setUser } = useContext(UserContext)
  const { setTransferData } = useContext(transferBeneficiaryContext)
  const { setRecharges } = useContext(RechargeContext)
  const { setPaimentFacture } = useContext(paimentFactureContext)
  const { setTransferDataBeneficiary } = useContext(transferBeneficiaryContext)

  if (!isOpen || !openModalLogOut) return null

  return ReactDOM.createPortal(
    <div
      className={classNames(
        'fixed inset-0 z-50 flex flex-col justify-center items-center bg-[rgba(87,84,229,0.6)] backdrop-blur-[5px]'
      )}
    >
       <img className='-mb-[25px]'
             width={88}
            height={88}
            src={logOutImage ?? LogOutImage}
          />
      <img src={Modal} width={327} height={78} alt=''/>
     
        <div className="pb-[24px] rounded-b-[16px] px-[24px] bg-[#FFF]  w-[327px] relative flex flex-col items-center text-center">
          <div className="font-bold text-[24px] text-[#1D3A70] ">
            {nomModal ?? 'Déconnexion'}
          </div>
          {description && (
            <h2 className="font-bold text-[20px] text-[#6B7280] my-3">
              {description}
            </h2>
          )}
          <div className="text-[16px] font-normal text-[#6B7280] mt-5">
            {confirmationText ?? 'Êtes-vous sûr de vouloir vous déconnecter ?'}
          </div>
          <div className="flex justify-center items-center gap-6 mt-8">
            <button
              className="text-[18px] font-bold border text-[#6B7280] border-[#6B7280] w-[106px] h-[60px] rounded-xl"
              onClick={closeModal}
            >
              Retour
            </button>
            <button
              className="text-white text-[18px] font-bold bg-[#EE443F] w-[160px] h-[60px] rounded-xl"
              onClick={() => {
                if (UpdateKYC && handleConfirmUpdate) {
                  UpdateKYC(true)
                  handleConfirmUpdate()
                } else {
                  localforage.clear()
                  setUser(null)
                  setTransferData(null)
                  setRecharges(null)
                  setPaimentFacture(null)
                  setTransferDataBeneficiary(null)
                  closeModal()
                  navigate('/login')
                }
              }}
            >
              Je confirme
            </button>
          </div>
         
        </div>
      
    </div>,
    document.body // ici le portal !
  )
}

export default ModalLogOutContainer
